import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  Chip,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  createTheme,
  ThemeProvider,
  Card,
  IconButton,
} from "@mui/material";

import { color } from "../../utils/constant";
import { resetState } from "../../data/reducers/Appointment/appointmentform.reducer";

import { getDoctorList } from "../../data/selectors/Appointment/appointment.selector";
import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
import { useSelector } from "react-redux";
import useAppointment from "../../data/talons/Appointment/useAppointment";
import MaterialUIPickers from "../../components/shared/DesktopDatePicker";
import { getAppointmnetData } from "../../data/selectors/Appointment/appointmentform.selector";
import { format } from "date-fns";
import Iconify from "../../components/iconify/iconify";
import Dialog from "../../components/shared/Dialog";
import LabReportForm from "./LabReportForm";
import { useAppointmentForm } from "../../data/talons/Appointment/useAppointmentForm";
import LabTestForm from "./LabTestForm";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import EmptyIcon from "../../assets/icons/empty/ic_content.svg";
import { useLabtestForm } from "../../data/talons/Appointment/useLabtestForm";
import { enqueueSnackbar } from "notistack";
import FileCopyIcon from "@mui/icons-material/FileCopy";


export default function AppointmentForm(props) {
  const { editId, backToAppointment } = props;

  const editItem = useSelector(getAppointmnetData);
  const { fetchPatientComboList, fetchDoctorComboList, fetchAppointmentList } =
    useAppointment();

  const doctorList = useSelector(getDoctorList);
  const [LabTestId, setLabTestId] = useState("");
  const [Id, setId] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [Open, setOpen] = useState(false);
  const [ReportDialogue, setReportDialogue] = useState(false);
  const [LabeditObj, setLabeditObj] = useState([]);
  const [AppLabTestId, setAppLabTestId] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const { getAppointmentbyId, AppointmentUpdate, NoteAdd, fetchNoteList } =
    useAppointmentForm();
  const [problem, setProblem] = useState(get(editItem, "problem", ""));
  const [notes, setNotes] = useState(get(editItem, "notes", ""));

  useEffect(() => {
    fetchDoctorComboList();
    fetchPatientComboList();
  }, []);

  const { labTestUpdate } = useLabtestForm();

  const onUserSubmit = useCallback(async () => {
    try {
      const res = await labTestUpdate(editId, LabTestId, Id);
      if (res === true) {
        await getAppointmentbyId(editId);
        setOpen(false);
      } else {
        enqueueSnackbar("Problem While Deleting Lab Test Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [LabTestId, Id, labTestUpdate]);

  const theme = createTheme({
    components: {
      MuiAccordion: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            margin: "0px",
            "&:before": {
              display: "none",
            },
          },
        },
      },
    },
  });

  const defaultValues = useMemo(() => ({
    appointmenTime: get(editItem, "appointment_time", ""),
    doctorName: get(editItem, "doctor_name", ""),
    name: get(editItem, "patient_name", ""),
    age: get(editItem, "age", ""),
    gender: get(editItem, "gender_val", ""),
    problem: get(editItem, "problem", ""),
    notes: get(editItem, "notes", ""),
  }));

  const { register, control, setValue } = useForm({
    resolver: joiResolver(),
    defaultValues,
  });

  const appointmentDate = new Date(
    get(editItem, "appointment_date", format(new Date(), "yyyy-MM-dd"))
  );

  const labtest =
    editItem?.appointment_lab_test?.length > 0
      ? editItem?.appointment_lab_test
      : null;

  const columns = [
    {
      field: "icon",
      headerName: "Icon",
      width: 150,
      renderCell: (cell) => {
        const { report_url } = cell.row;
        const fileType = report_url.split(".")[2];

        return (
          <Box sx={{}}>
            {["jpeg", "jpg", "png", "webp"].includes(fileType) ? (
              <Iconify icon="mdi:image" width={24} height={30} /> // Image icon
            ) : ["pdf"].includes(fileType) ? (
              <Iconify icon="mdi:file-pdf" width={24} height={24} /> // PDF icon
            ) : (
              <Iconify icon="mdi:file" width={24} height={24} /> // Generic file icon
            )}
          </Box>
        );
      },
    },
    { field: "report_name", headerName: "Name", flex: 1 },
    { field: "insert_datetime", headerName: "Date", flex: 1 },
    { field: "remark", headerName: "Remark", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      width: 200,
      renderCell: (cell) => {
        return (
          <>
            <IconButton
              // color="secondary"
              aria-label="add an alarm"
              size="small"
              onClick={() => {
                setReportDialogue(true);
                setLabeditObj(cell.row);
                setAppLabTestId(cell.row.appointment_lab_test_id);
              }}
            >
              <Iconify icon="solar:pen-bold" />
            </IconButton>

            {/* <IconButton
              color="error"
              onClick={() => {
                deleteBlog(cell.row._id);
                return;
              }}
            >
              <DeleteIcon />
            </IconButton> */}
          </>
        );
      },
    },
  ];
  const MyCustomNoRowsOverlay = () => (
    <Stack mt={5} alignItems="center" justifyContent="center">
      {/* <Box
        component="img"
        alt="empty content"
        src={EmptyIcon}
        sx={{ width: 1, maxWidth: 160 }}
      /> */}
      <Typography
        variant="h6"
        component="span"
        sx={{ mt: 1, color: "text.disabled", textAlign: "center" }}
      >
        {"No Data"}
      </Typography>
    </Stack>
  );

  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" gutterBottom>
        Appointment Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={4} sm={6} md={4}>
          <MaterialUIPickers
            required
            disabled={editId ? true : false}
            id="appointment_date"
            label="Appointment Date"
            type="date"
            value={appointmentDate}
            size={"small"}
            sx={{ width: "100%" }}
            InputLabelProps={{
              shrink: true,
            }}
          ></MaterialUIPickers>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            required
            disabled={editId ? true : false}
            id="appointment_time"
            name="appointmenTime"
            label="Appointment Time"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("appointmenTime")}
            autoComplete="false"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <RHFAutocomplete
            borderRadius={"0px"}
            isRequired={true}
            name="doctorName"
            label="Doctor Name"
            disabled={editId ? true : false}
            freeSolo
            data={doctorList || []}
            defaultValue={editItem?.doctor_id}
            id={doctorList?.map((option) => option.id)}
            renderOption={(props, option) => (
              <>
                <li {...props} key={option}>
                  {option}
                </li>
              </>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={option}
                  size="small"
                  color="info"
                  variant="soft"
                />
              ))
            }
            control={control}
            setValue={setValue}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={4}>
          <TextField
            required
            disabled={editId ? true : false}
            id="name"
            name="name"
            label="Name"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("name")}
            autoComplete="false"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            required
            disabled={editId ? true : false}
            id="age"
            name="age"
            label="Age"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("age")}
            autoComplete="false"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            required
            disabled={editId ? true : false}
            id="gender"
            name="gender"
            label="Gender"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("gender")}
            autoComplete="false"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="problem"
            name="problem"
            label="Problem"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            minRows={3}
            inputProps={{
              maxLength: 100,
            }}
            {...register("problem")}
            // value={problem}
            onChange={(e) => {
              setProblem(e.target.value);
            }}
            autoComplete="false"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            id="notes"
            name="notes"
            label="Notes"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            minRows={4}
            inputProps={{
              maxLength: 500,
            }}
            {...register("notes")}
            // value={problem}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
            autoComplete="false"
          />
        </Grid>

        <Dialog
          handleClose={() => {
            setShowDialog(false);
            // setEditId(null);
            // dispatch(resetState());
            // fetchAreaList({ current_page: 1, row_count: rowsPerPage });
          }}
          open={showDialog}
          fullWidth={true}
        >
          <LabTestForm
            postSubmit={() => {
              // await getAppointmentbyId(editId);
              setShowDialog(false);
            }}
            selectedlabTest={labtest}
            appointmentId={editId}
          />
        </Dialog>
        <Dialog
          handleClose={() => {
            setOpen(false);
          }}
          open={Open}
          // fullWidth={true}
        >
          <Typography sx={{ fontWeight: "bold" }}>
            Confirm to Delete this lab test ?.
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "end" }}>
            <Button
              onClick={() => onUserSubmit()}
              sx={{ background: color.button }}
              variant="contained"
            >
              Yes
            </Button>
            <Button
              onClick={() => setOpen(false)}
              sx={{ background: color.button }}
              variant="contained"
            >
              No
            </Button>
          </Box>
        </Dialog>
        <Dialog
          handleClose={() => {
            setShowDialog(false);
            // setEditId(null);
            // dispatch(resetState());
            // fetchAreaList({ current_page: 1, row_count: rowsPerPage });
          }}
          open={ReportDialogue}
          fullWidth={true}
        >
          <LabReportForm
            postSubmit={async () => {
              await getAppointmentbyId(editId);
              setReportDialogue(false);
            }}
            editId={editId}
            editItem={LabeditObj}
            appTestId={AppLabTestId}
          />
        </Dialog>
        <Grid
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          mt={3}
          ml={2}
        >
          <Typography variant="h5" fontStyle={"revert-layer"}>
            Lab Test
          </Typography>
          <Box
            sx={{
              backgroundColor: color.button,
              "&:hover": {
                backgroundColor: color.button,
              },
              color: "white",
              maxWidth: "fit-content",
              width: "fit-content",
              borderRadius: "40px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowDialog(true);
              // setLabeditObj(item);
            }}
            variant="contained"
          >
            <Iconify sx={{ m: 1 }} icon="mingcute:add-line" />
          </Box>
        </Grid>
        <Grid xs={12} sx={{ mt: 3 }}>
          {labtest?.length > 0
            ? labtest.map((item) => {
                const report = item?.appointment_lab_test_reports;

                return (
                  <Accordion
                    sx={{
                      width: "100%",
                      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                    }}
                    key={item.id}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Typography>{item.test_name}</Typography>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Box
                            sx={{
                              backgroundColor: color.button,
                              "&:hover": {
                                backgroundColor: color.button,
                              },
                              color: "white",
                              maxWidth: "fit-content",
                              width: "fit-content",
                              borderRadius: "40px",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={(event) => {
                              event.stopPropagation();
                              setReportDialogue(true);
                              setLabeditObj([]);
                              setAppLabTestId(item.id);
                            }}
                            variant="contained"
                          >
                            <Iconify sx={{ m: 1 }} icon="mingcute:add-line" />
                          </Box>
                          <Box
                            sx={{
                              backgroundColor: color.button,
                              "&:hover": {
                                backgroundColor: color.button,
                              },
                              color: "white",
                              maxWidth: "fit-content",
                              width: "fit-content",
                              borderRadius: "40px",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={(event) => {
                              event.stopPropagation();
                              setOpen(true);
                              setLabTestId(item.lab_test_id);
                              setId(item.id);
                            }}
                            variant="contained"
                          >
                            <Iconify
                              sx={{ m: 1 }}
                              icon="solar:trash-bin-trash-bold"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ mb: 0 }}>
                      {/* <Box sx={{ width: "100%" }}>
                    <DataGrid
                      // rows={rows}3
                      columns={columns}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                          },
                        },
                      }}
                      pageSizeOptions={[5]}
                      // checkboxSelection
                      disableRowSelectionOnClick
                    />
                    </Box> */}

                      <Card
                        sx={{
                          flexGrow: { md: 1 },
                          display: { md: "flex" },
                          flexDirection: { md: "column" },
                          // mt: "12px",
                        }}
                      >
                        <DataGrid
                          // rowHeight={150}
                          headerHeight={50}
                          columns={columns}
                          rows={report}
                          disableColumnMenu
                          autoHeight={true}
                          pageSize={0}
                          hideFooterPagination={true}
                          getRowId={(row) => row.id}
                          sx={{
                            // mt: 1,
                            // boxShadow: '0px 0px 8px 10px #f7f7f7',
                            // background: colorChange ? colorChange.toString() : '#fff',
                            border: "none",

                            "& .MuiDataGrid-columnHeaderTitle": {
                              // color: 'var(--theme-color)',
                              // fontWeight: 600,
                            },
                            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar":
                              {
                                width: "0.4em",
                                height: "0.4em",
                                color: "rgba(145, 158, 171, 0.12)",
                              },
                            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track":
                              {
                                background: "#f1f1f1",
                              },
                            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                              {
                                borderRadius: 5,
                                // background:
                                //   theme.palette.mode === "light"
                                //     ? theme.palette.grey[500]
                                //     : theme.palette.grey[600],
                              },
                          }}
                          slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                        />
                      </Card>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            : ""}
        </Grid>
        <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              disabled={editId ? true : false}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={editItem?.status === 1 ? true : false}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid>
        <Grid container direction="row" mt={5}>
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={async (e) => {
                  e.preventDefault();
                  try {
                    const updateResult = await AppointmentUpdate({
                      id: editId,
                      problem: problem,
                      notes: notes,
                    });
                    if (updateResult) {
                      await fetchAppointmentList({
                        current_page: 1,
                        row_count: rowsPerPage,
                      });
                    } else {
                      enqueueSnackbar(
                        "Failed to update appointment or add note",
                        {
                          variant: "error",
                        }
                      );
                    }
                  } catch (error) {
                    console.error("Error during appointment update:", error);
                    enqueueSnackbar(
                      "An error occurred while updating the appointment",
                      {
                        variant: "error",
                      }
                    );
                  }

                  // Navigate back after submission
                  backToAppointment();
                }}
              >
                Save
              </Button>

              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={() => backToAppointment()}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
